import { useAxios } from "../../../../../../hooks/useAxios"
import { DiaFestivoAdapters, DiasFestivosAdapters } from "../adapters/diasfestivos.adapter"

const DiasFestivosServices = {

    POST_MOSTRAR_FECHAS: function () {

        return useAxios({ method: 'post', url: `/maestros/allfechas`, type: 'json', adapters: DiasFestivosAdapters.GET })
    },
}

const DiaFestivoServices = {

    GET: function (fecha: string) {

        return useAxios({ method: 'get', url: `/maestros/fecha/${fecha}`, type: 'json', adapters: DiaFestivoAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/maestros/fechas`, type: 'json', adapters: DiaFestivoAdapters.POST })
    },

    PATCH: function (fecha: string) {

        return useAxios({ method: 'patch', url: `/maestros/fechas/${fecha}/update`, type: 'json', adapters: DiaFestivoAdapters.PATCH })
    },

    DELETE: function () {

        return useAxios({ method: 'delete', url: `/maestros/fecha`, type: 'json', adapters: DiaFestivoAdapters.DELETE })
    }
}

export {
    DiasFestivosServices,
    DiaFestivoServices
}